import { render, staticRenderFns } from "./PrimeVideoUploader.vue?vue&type=template&id=b669d682&scoped=true"
import script from "./PrimeVideoUploader.vue?vue&type=script&lang=js"
export * from "./PrimeVideoUploader.vue?vue&type=script&lang=js"
import style0 from "./PrimeVideoUploader.vue?vue&type=style&index=0&id=b669d682&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b669d682",
  null
  
)

export default component.exports